import { render } from "./CustomTagInput.vue?vue&type=template&id=bbdd4b46&scoped=true"
import script from "./CustomTagInput.vue?vue&type=script&lang=js"
export * from "./CustomTagInput.vue?vue&type=script&lang=js"

import "./CustomTagInput.vue?vue&type=style&index=0&id=bbdd4b46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbdd4b46"]])

export default __exports__